import { Container } from '@pixi/react'
import hs_speed_on_normal from '../../asset/images/menu/turbo_on_normal.png'
import hs_speed_on_hover from '../../asset/images/menu/turbo_on_hover.png'
import hs_speed_on_click from '../../asset/images/menu/turbo_on_click.png'
import hs_speed_disabled from '../../asset/images/menu/turbo_on_unable.png'
import hs_speed_off_click from '../../asset/images/menu/turbo_off_click.png'
import hs_speed_off_hover from '../../asset/images/menu/turbo_off_hover.png'
import hs_speed_off_normal from '../../asset/images/menu/turbo_on_unable.png'
import enable_on from '../../asset/images/menu/turbo_off_normal.png'

import { Assets } from 'pixi.js'
import { ButtonProps } from './menu/interface/ButtonProps'
import { Button, soundManager, SoundType, useSpeedStore } from '@slot-nx/core'
import { useEffect } from 'react'
import { useSelector } from '@xstate/react'
import { GameState, sweetBombMachine } from '../../machine/sweetbombMachine'

Assets.addBundle('HSSpeedButton', {
  hs_speed_on_click: { src: hs_speed_on_click, loadParser: 'loadTextures' },
  hs_speed_on_hover: { src: hs_speed_on_hover, loadParser: 'loadTextures' },
  hs_speed_on_normal: { src: hs_speed_on_normal, loadParser: 'loadTextures' },
  hs_speed_disabled: { src: hs_speed_disabled, loadParser: 'loadTextures' },
  hs_speed_off_click: { src: hs_speed_off_click, loadParser: 'loadTextures' },
  hs_speed_off_hover: { src: hs_speed_off_hover, loadParser: 'loadTextures' },
  hs_speed_off_normal: { src: hs_speed_off_normal, loadParser: 'loadTextures' },
  enable_on: { src: enable_on, loadParser: 'loadTextures' },
})

export const SpeedButton = (props: ButtonProps) => {
  const isEnable = useSpeedStore(x => x.isEnabled)

  const onPress = () => {
    useSpeedStore.setState({ isEnabled: !isEnable })
  }

  const currentState = useSelector(sweetBombMachine, state => state)
  useEffect(() => {
    if (currentState.matches(GameState.freeGameEntry)) {
      useSpeedStore.setState({ isEnabled: false })
    }
  }, [currentState])

  return (
    <Container position={[props.x, props.y]}>
      {
        isEnable
          ? (
              <Button
                name="hs_speed off Button"
                defaultView="enable_on"
                hoverView="hs_speed_off_hover"
                pressedView="hs_speed_off_click"
                disabledView="hs_speed_disabled"
                enabled={true}
                x={0}
                y={0}
                width={props.width}
                height={props.height}
                key="off"
                onPressing={() => {
                  soundManager.play(SoundType.buttonConfirm)
                }}
                onPress={onPress}
              />
            )
          : (
              <Button
                name="speed on Button"
                defaultView="hs_speed_on_normal"
                hoverView="hs_speed_on_hover"
                pressedView="hs_speed_on_click"
                disabledView="hs_speed_disabled"
                enabled={true}
                x={0}
                y={0}
                width={props.width}
                height={props.height}
                key="on"
                onPressing={() => {
                  soundManager.play(SoundType.buttonConfirm)
                }}
                onPress={onPress}
              />
            )

      }
    </Container>
  )
}
